import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { useSettingsStore } from '../../../common'

import { NotificationProfile } from './NotificationProfile'

export const InsightsNotificationProfiles = observer(() => {
  const { insightsProfiles } = useSettingsStore()

  return (
    <Stack>
      {insightsProfiles.map((profile) => (
        <NotificationProfile key={profile.guid} profile={profile} />
      ))}
    </Stack>
  )
})
